<template>
  <div>
    <div class="d-flex flex-row-column">
      <span class="page-title mt-2">Staff Accounts</span>
      <span class="input-width-330 px-2 r-width-100 d-inline-block ml-auto">
        <md-field>
          <label>Search</label>
          <md-input v-on:keyup="search" v-model="search_term"></md-input>
          <md-icon>search</md-icon>
        </md-field>
      </span>
      <md-button @click="$router.push('/bank/staff/create')" class="md-primary md-raised c-primary">
        <md-icon>add</md-icon>Create
      </md-button>
    </div>
    <hr class="hr-line" />
    <md-table v-show="!loading" v-if="items.length>0" v-model="items">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
        <md-table-cell md-label="Role" md-sort-by="role">{{item.role.description}}</md-table-cell>
        <md-table-cell md-label="Email" md-sort-by="email" class="blue-cell">{{ item.email }}</md-table-cell>

        <md-table-cell md-label="Address" md-sort-by="address">{{ item.address }}</md-table-cell>
        <md-table-cell md-label="Actions">
          <md-menu class="ml--10" md-size="big" md-align-trigger>
            <md-button md-menu-trigger class="blue-cell">
              Choose
              <i class="fas fa-chevron-down pl-1"></i>
            </md-button>

            <md-menu-content class="md-dropdown">
              <md-menu-item   v-if="!item.primary_acc" @click="$router.push('/bank/staff/'+item.id)">
                Edit
                <img src="../../../assets/icons/iconDropDownEdit.svg" alt="edit" />
              </md-menu-item>
              <md-menu-item v-if="myType" @click="resetPassword(item.id)">
                Reset Password
                <img src="../../../assets/icons/iconDropDownPassword.svg" alt="edit" />
              </md-menu-item>
              <md-menu-item   v-if="!item.primary_acc" class="red-element"  @click="blockStaff(item.id)">
                <template v-if="item.blocked">Unblock</template>
                <template v-else>Block</template>
                <img src="../../../assets/icons/iconDropDownBlock.svg" alt="edit" />
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <pagination
      v-on:change="paginationChange($event)"
      v-on:change_per_page="changePerPage($event)"
      v-if="items.length>0&&pagination"
      :meta="pagination.meta"
      :links="pagination.links"
      :per_page="per_page"
    />

    <empty-state v-if="!loading&&items.length==0" />

    <loading v-if="loading" />

    <confirm type="user" v-if="confirm" @cancel="onCancel" @confirm="onConfirm" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// import CRUD methods for users
import Users from "../../../mixins/users.js";

// Confirmation component before deleting user
import ConfirmDelete from "../../../components/owner/ConfirmDelete";

// mixin for loading datas and state
import DataMixin from "../../../mixins/data.js";

export default {
  mixins: [Pagination, Users, DataMixin],
  components: {
    confirm: ConfirmDelete
  },
  data() {
    return {
      search_term: "",
      // url for loading data
      api_url: "/lmt/staff/show",
      //IMPORTANT loaded data is stored in items
      items: [],
      myID: auth.getID(),
      myType:auth.getUser().primary_acc
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    blockStaff(id) {
      window.axios.post("/lmt/staff/block?id=" + id).then(({ data }) => {
        Event.$emit("message", [data.message]);
        this.loadData();
      });
    }
  }
};
</script>